var _style, _path, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIconDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#393939;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{font-family:'ArialMT';}\r\n\t.st3{font-size:12px;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,3.8v13.1c0,3.1,2.5,5.6,5.6,5.6h13.1v28.1c0,3.1-2.5,5.6-5.6,5.6l0,0H16.9c-3.1,0-5.6-2.5-5.6-5.6l0,0V9.4 c0-3.1,2.5-5.6,5.6-5.6C16.9,3.8,30,3.8,30,3.8z M33.8,4.7v12.2c0,1,0.8,1.9,1.9,1.9l0,0h12.2L33.8,4.7L33.8,4.7z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.6848 37.6537)",
    className: "st1 st2 st3"
  }, ".DOC")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIconDoc);
export default __webpack_public_path__ + "static/media/DocumentIconDOC.756f04ce7b5f3a578e2a130465772ef4.svg";
export { ForwardRef as ReactComponent };